import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@material-ui/core';
import DayJsUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { KeyboardDateTimePicker } from 'formik-material-ui-pickers';
import { Button } from '@vadiun/react-components';
import { Field, Form, Formik } from 'formik';
import moment, { Moment } from 'moment';
import { FC, useEffect, useState } from 'react';
import {
  ContingencyReason,
  ContingencyType,
  contingencyService
} from 'app/viaje/viajeTraslado/coordinar/services/contingencyService';
import { ContingencyFilters } from '../hooks/useContingencies';

type FormType = {
  contingency_reason_id: number | '';
  contingency_type_id: number | '';
  polygon_zone_id: number | '';
  applied_by_user_id: number | '';
  applied_at: Moment | null;
  finished_at: Moment | null;
  observation: string;
};

const toForm = (filters: ContingencyFilters): FormType => ({
  contingency_reason_id: filters.contingency_reason_id ?? '',
  contingency_type_id: filters.contingency_type_id ?? '',
  polygon_zone_id: filters.polygon_zone_id ?? '',
  applied_by_user_id: filters.applied_by_user_id ?? '',
  applied_at: filters.applied_at ? moment(filters.applied_at) : null,
  finished_at: filters.finished_at ? moment(filters.finished_at) : null,
  observation: filters.observation ?? ''
});

const toFilters = (values: FormType): ContingencyFilters => {
  const next: ContingencyFilters = {};
  if (values.contingency_reason_id !== '') {
    next.contingency_reason_id = Number(values.contingency_reason_id);
  }
  if (values.contingency_type_id !== '') {
    next.contingency_type_id = Number(values.contingency_type_id);
  }
  if (values.polygon_zone_id !== '') {
    next.polygon_zone_id = Number(values.polygon_zone_id);
  }
  if (values.applied_by_user_id !== '') {
    next.applied_by_user_id = Number(values.applied_by_user_id);
  }
  if (values.applied_at) {
    next.applied_at = values.applied_at.toISOString();
  }
  if (values.finished_at) {
    next.finished_at = values.finished_at.toISOString();
  }
  if (values.observation.trim() !== '') {
    next.observation = values.observation.trim();
  }
  return next;
};

interface Props {
  initialValues: ContingencyFilters;
  onSubmit: (filters: ContingencyFilters) => void;
}

const ContingenciesFilters: FC<Props> = ({ initialValues, onSubmit }) => {
  const [reasons, setReasons] = useState<ContingencyReason[]>([]);
  const [types, setTypes] = useState<ContingencyType[]>([]);
  const service = contingencyService();

  useEffect(() => {
    service.getContingencyReasons().then(setReasons).catch(() => {});
    service.getContingencyTypes().then(setTypes).catch(() => {});
  }, []);

  return (
    <Formik<FormType>
      enableReinitialize
      initialValues={toForm(initialValues)}
      onSubmit={(values) => onSubmit(toFilters(values))}
    >
      {({ values, setFieldValue }) => (
        <Form className="flex flex-col gap-4 p-4">
          <FormControl variant="outlined" fullWidth>
            <InputLabel id="reason-label">Razón</InputLabel>
            <Select
              labelId="reason-label"
              label="Razón"
              value={values.contingency_reason_id}
              onChange={(e) =>
                setFieldValue('contingency_reason_id', e.target.value)
              }
            >
              <MenuItem value="">Todas</MenuItem>
              {reasons.map(({ id, label }) => (
                <MenuItem value={id} key={id}>
                  {label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl variant="outlined" fullWidth>
            <InputLabel id="type-label">Tipo</InputLabel>
            <Select
              labelId="type-label"
              label="Tipo"
              value={values.contingency_type_id}
              onChange={(e) =>
                setFieldValue('contingency_type_id', e.target.value)
              }
            >
              <MenuItem value="">Todos</MenuItem>
              {types.map(({ id, label }) => (
                <MenuItem value={id} key={id}>
                  {label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* <TextField
            variant="outlined"
            fullWidth
            label="ID de zona de polígono"
            type="number"
            value={values.polygon_zone_id}
            onChange={(e) => setFieldValue('polygon_zone_id', e.target.value)}
          />

          <TextField
            variant="outlined"
            fullWidth
            label="ID usuario que aplicó"
            type="number"
            value={values.applied_by_user_id}
            onChange={(e) =>
              setFieldValue('applied_by_user_id', e.target.value)
            }
          /> */}

          <MuiPickersUtilsProvider utils={DayJsUtils}>
            <Field
              name="applied_at"
              label="Fecha de aplicación"
              inputVariant="outlined"
              component={KeyboardDateTimePicker}
              fullWidth
              ampm={false}
              format="DD/MM/YYYY HH:mm"
              clearable
            />
            <Field
              name="finished_at"
              label="Fecha de finalización"
              inputVariant="outlined"
              component={KeyboardDateTimePicker}
              fullWidth
              ampm={false}
              format="DD/MM/YYYY HH:mm"
              clearable
            />
          </MuiPickersUtilsProvider>

          <TextField
            variant="outlined"
            fullWidth
            label="Observación"
            value={values.observation}
            onChange={(e) => setFieldValue('observation', e.target.value)}
          />

          <div className="flex justify-end mt-2">
            <Button type="submit" variant="contained">
              Aplicar filtros
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ContingenciesFilters;
